<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="loadIndexData()"></div>-->
    <div id="contentDiv">
      <div id="taskAndClassDiv">
        <!--最新任务消息-->
        <!--<div id="newTaskMsgDiv">
          <div class="divHead divHeadOne">
            <div class="divHead_title">
              <div class="num_tip" :class="{tip_need: newTaskNum != ''}">{{newTaskNum}}</div>最新任务消息
            </div>
            <span @click="changeMenuClass('/task')">
              <router-link to="/task">更多&gt;&gt;</router-link>
            </span>
          </div>
          <div class="divBody divBodyOne">
            <table class="table tabShow">
              <tbody>
              <tr v-for="(task, index) in newTaskList" :key="index">
                <td style="width: 0%;"><div class="noRead_tip" :class="{tip_need: task.status == 0}"></div></td>
                <td class="tabTd_content_ellipsis tabTd_name_one" :title="task.className">{{task.className}}</td>
                <td class="tabTd_content_ellipsis tabTd_status_one tabTd_status_one_noRead" :title="task.content">{{task.content}}</td>
                <td class="tabTd_content_ellipsis tabTd_time_one" :title="task.createTime">{{task.createTime}}</td>
                <td class="tabTd_btn_one">
                  <button type="button" class="btn btn-default btn_option" @click="clazzId=task.classId;publishStatus=task.checkStatus;classStatus=task.stuStatus;saveDataIntoStorage()">去查看</button>
                  <button type="button" class="btn btn-default btn_option" v-if="task.status == 0" @click="ignoreTask(task.id)">忽略</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>-->
        <!--最新班级状态-->
        <div id="newClassStatusDiv">
          <div class="divHead divHeadTwo">
            <div class="divHead_title">
              <div class="num_tip"></div>最新班级状态
            </div>
            <span @click="changeMenuClass('/class')">
              <router-link to="/class">更多&gt;&gt;</router-link>
            </span>
          </div>
          <div class="divBody divBodyTwo">
            <table class="table tabShow">
              <tbody>
              <tr v-for="(classOne, index) in newClassList" :key="index">
                <!--<td style="width: 0%;"><div class="warning_tip tip_need">!</div></td>-->
                <td class="tabTd_content_ellipsis tabTd_name_two" :title="classOne.name">{{classOne.name}}</td>
                <td class="tabTd_publish_two" :title="classOne.checkStatus | turnPublishStatusWord">{{classOne.checkStatus | turnPublishStatusWord}}</td>
                <td class="tabTd_publish_two" :title="classOne.status | turnClassStatusWord">{{classOne.status | turnClassStatusWord}}</td>
                <td class="tabTd_content_ellipsis tabTd_time_two" :title="classOne.startDate">{{classOne.startDate}}</td>
                <td class="tabTd_btn_two">
                  <button type="button" class="btn btn-default btn_option"
                          @click="clazzId=classOne.id;publishStatus=classOne.checkStatus;classStatus=classOne.status;saveDataIntoStorage()">
                    <span @click="changeMenuClass('/class')">
              <!--<router-link to="/class" style="color: white"> 查看</router-link>-->
                      查看
            </span>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--最新通知信息-->
      <div id="newMsgDiv">
        <div class="divHead divHeadThree">
          <div class="divHead_title">
            <div class="num_tip"></div>最新通知信息
          </div>
          <span @click="changeMenuClass('/message')">
            <router-link to="/message">更多&gt;&gt;</router-link>
          </span>
        </div>
        <div class="divBody divBodyThree">
          <table class="table tabShow">
            <tbody>
            <tr v-for="(msgOne, index) in newMsgList" :key="index">
              <td class="tabTd_image_three"><span class="glyphicon glyphicon-envelope"></span><!--<div class="email_image"></div>--></td>
              <td class="tabTd_content_ellipsis tabTd_name_three">@{{msgOne.recName}}</td>
              <td class="tabTd_content_ellipsis tabTd_context_three">
                <b>{{msgOne.title}}</b>
                <span>——</span>
                <span>{{msgOne.content}}</span>
              </td>
              <td class="tabTd_time_three">{{msgOne.createTime}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--网络课堂-->
      <div id="classRoomMsgDiv">
        <div class="divHead divHeadFour">
          <div class="divHead_title">
            <div class="num_tip"></div>网络课堂
          </div>
          <span @click="changeMenuClass('/classRoom')">
            <router-link to="/classRoom">更多&gt;&gt;</router-link>
          </span>
        </div>
        <div class="divBody divBodyFour">
          <div class="videoDiv">
            <div v-for="(videoLi,index) in videoList" :key="index" class="videoImgPath" @click="videoTitle=videoLi.title;videoTeacher=videoLi.teacher;openVideoModal(videoLi.filePath)">
              <!--<img src="../assets/img/back_bg/ht_sp_1.png"/>-->
              <img v-if="videoLi.tpfilePath" :src="resourcesPath + videoLi.tpfilePath"/>
              <img v-else src="../assets/img/back_bg/ht_sp_1.png"/>
              <div class="video_title">{{videoLi.title}} —— {{videoLi.teacher}}</div>
            </div>
          </div>
        </div>
      </div>
      <!--视频显示框-->
      <div class="modal fade" id="myModal_showVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showVideo" aria-hidden="true" data-backdrop='static'>
        <div class="modal-dialog modal-dialog-look">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                &times;
              </button>
              <h4 class="modal-title" id="myModalLabel_showVideo">
                {{videoTitle}} —— {{videoTeacher}}
              </h4>
            </div>
            <div class="modal-body modal-body-look">
              <video class="showVideo video-js" :src="videoSrc" :type="videoType" controls="controls" controlslist="nodownload" autoplay="autoplay" loop="loop" :poster="videoThumbSrc">
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import {schoolAxios} from '../main';

  import {getContentSize} from './mainView';

  import dictionaryData from '../json/dictionary';

  import mainViewVue from './mainView';

  export default {
    name: "index",
    data() {
      return {
        clazzId : '',
        publishStatus : 0,
        classStatus : 0,
        //最新任务消息
        newTaskList: [],
        newTaskNum: '',
        //最新班级状态
        newClassList: [],
        //班级发布状态标识
        check_status: dictionaryData.check_status,
        //最新通知消息
        newMsgList: [],
        //移动课堂
        videoList: [],
        videoSrc: '',
        videoThumbSrc: '',
        videoType: 'video/mp4',
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,
        resourcesPath:this.$store.state.serviceBase + "resources/",

        videoTitle:'',
        videoTeacher:'',
      }
    },
    filters: {
      turnPublishStatusWord(value){
        let this_ = this;
        if(dictionaryData.check_status && value){
          value = dictionaryData.check_status[value];
        }
        return value;
      },
      turnClassStatusWord(value){
        let this_ = this;
        if(dictionaryData.clazz_status && value){
          value = dictionaryData.clazz_status[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        //绑定加载关闭视频模态框时的事件
        this_.closeModal();

        this_.loadIndexData();

        this_.loadLeaderIndexData();

        // this_.hideVideoTitle();
      });
    },
    methods: {
      /**
       * 加载首页数据
       */
      loadIndexData(){
        let this_ = this;
        axios.all([
          schoolAxios({
            method: 'get',
            url: 'tasks/findList',
            params: {}
          }),
          /*schoolAxios({
            method: 'get',
            url: 'clazz/findPage',
            params: {
              'page': '1',
              'rows': '6'
            }
          }),*/
          schoolAxios({
            method: 'get',
            url: 'notice/findListByCreator',
            params: {
              'page': '1',
              'rows': '6'
            }
          }),
          schoolAxios({
            method: 'get',
            url: 'mobileLearning/findDetailsPage',
            params: {
              'page': '1',
              'rows': '6'
            }
          }),
        ]).then(
          axios.spread(function (taskResp, msgResp, videoResp) {
            //最新任务消息
            let taskData = taskResp.data;
            if(taskData.success){
              this_.newTaskList = taskData.list;
              this_.loadNewTaskNum();
            }

            //最新班级状态
            /* let classData = classResp.data;
             if(classData.success){
               this_.newClassList = classData.list;
             }*/

            //最新通知消息
            let msgData = msgResp.data;
            if(msgData.success){
              this_.newMsgList = msgData.list;
            }

            //移动课堂
            let videoData = videoResp.data;
            if(videoData.success){
              this_.videoList = videoData.list;
            }
          })
        );
      },
      /**
       * 加载最新任务条数
       */
      loadNewTaskNum(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'tasks/getCountBy',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.newTaskNum = data.data!=0?data.data:'';
          }
        })
      },
      /**
       * 重载任务数据
       */
      reloadTasksMsg(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'tasks/findList',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.newTaskList = data.list;
            this_.loadNewTaskNum();
          }
        })
      },
      /**
       * 任务忽略
       */
      ignoreTask(id){
        let this_ = this;
        schoolAxios({
          method: 'put',
          url: 'tasks/edit/'+id,
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.reloadTasksMsg();
          }else{
            "操作失败".showMessage();
          }
        })
      },
      /**
       * 跳转路由保存数据
       */
      saveDataIntoStorage(){
        let this_ = this;
        //保存或修改

        this_.$store.set("clazzId", this_.clazzId);
        this_.$store.set("publishStatus", this_.publishStatus);
        this_.$store.set("classStatus", this_.classStatus);
        //路由跳转
        this_.$router.push({
          name: 'OpenClassMessage',//this_.classStatus==0?'OpenClassMessage':'ClassBasisAfter',
        });
      },
      /**
       * 打开视频模态框
       */
      openVideoModal(filePath) {
        let this_ = this;
        this_.videoSrc = this_.$store.state.serviceBase + "resources/" + filePath;
        $("#myModal_showVideo").modal("show");
      },
      /**
       * 关闭视频模态框监听
       */
      closeModal() {
        let this_ = this;
        $('#myModal_showVideo').on('hide.bs.modal', function () {
          this_.videoSrc = "";
        });
      },

      /**
       * 手动改变菜单样式
       * @param path
       */
      changeMenuClass(path){
        let this_ = this;
        mainViewVue.methods.changeMenuClass(path);
      },
      loadLeaderIndexData (){
        let this_ = this;
        /*console.info(this_.leaderUserCode);
        console.info(this_.userCode);*/
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1){
          schoolAxios({
            method: 'get',
            url: 'clazz/findAllPage',
            params: {
              'page': '1',
              'rows': '6'
            }
          }).then(function (resp) {
            // console.info(resp);
            let classData = resp.data;
            if(classData.success){
              this_.newClassList = classData.list;
            }
          });
        }else {
          schoolAxios({
            method: 'get',
            url: 'clazz/findPage',
            params: {
              'page': '1',
              'rows': '6'
            }
          }).then(function (resp) {
            // console.info(resp);
            let classData = resp.data;
            if(classData.success){
              this_.newClassList = classData.list;
            }
          });
        }
      }
    }
  }
</script>

<style scoped>
  @import "../assets/css/index.css";
  @import "../assets/css/publicStyle.css";
  @import '../assets/css/plugins.css';
</style>



// WEBPACK FOOTER //
// src/components/index.vue